
import { FirearmEntityDecorator } from '../../firearm/model/firearm.decorator';
import { Firearm } from '../../firearm/model/firearm.model';
import { FirearmStorageLocationEntityDecorator } from '../../firearm_storage_location/model/firearm-storage-location.decorator';
import { FirearmStorageLocation } from '../../firearm_storage_location/model/firearm-storage-location.model';
import { RangerEntityDecorator } from '../../ranger/model/ranger.decorator';
import { Ranger } from '../../ranger/model/ranger.model';
import { TransferAssetEntityDecorator } from '../../transferasset/model/transfer-asset.decorator';
import { TransferAsset } from '../../transferasset/model/transfer-asset.model';
import { AssetsUserDetailsEntityDecorator } from '../../userdetails/model/assets-user-details.decorator';
import { AssetsUserDetails } from '../../userdetails/model/assets-user-details.model';
import { FIREARM_ASSIGNMENT_METADATA } from './firearm-assignment.metadata';
import { FirearmAssignment } from './firearm-assignment.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class FirearmAssignmentEntityDecoratorBase extends GenericEntityDecorator<FirearmAssignment, number> {
  constructor() {
    super(FIREARM_ASSIGNMENT_METADATA, {
      get firearm(): EntityDecorator<Firearm, number> {
        return new FirearmEntityDecorator();
      },
      get gunDealerLocation(): EntityDecorator<FirearmStorageLocation, number> {
        return new FirearmStorageLocationEntityDecorator();
      },
      get location(): EntityDecorator<FirearmStorageLocation, number> {
        return new FirearmStorageLocationEntityDecorator();
      },
      get ranger(): EntityDecorator<Ranger, number> {
        return new RangerEntityDecorator();
      },
      get transferAsset(): EntityDecorator<TransferAsset, number> {
        return new TransferAssetEntityDecorator();
      },
      get user(): EntityDecorator<AssetsUserDetails, string> {
        return new AssetsUserDetailsEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.firearmAssignmentId == null) {
      return null;
    }
    return parseInt(params.firearmAssignmentId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: FirearmAssignment): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




